/* eslint-disable react/jsx-props-no-spreading */
import React, { forwardRef } from 'react';
import { Checkbox, CheckboxGroup, Form } from 'rsuite';
import { FormFieldSize } from 'components/Form/CustomForm/CustomForm';
import FieldLabel from '../../../Control/FormControlLabel';
// eslint-disable-next-line import/no-unresolved
import styles from './CheckboxFormField.module.scss';

export interface ICheckboxData {
  label: string;
  value: any;
}

interface ICheckboxFormField {
  name: string; // name of the key to map to
  helpMessage?: string; // help message to display
  label: string; // field label
  checkboxes: ICheckboxData[]; // checkboxes to render
  className?: any; // custom class name for form field group
  size?: FormFieldSize;
}

/**
 * Renders a checkbox
 */
const CheckboxFormField = forwardRef(
  (props: ICheckboxFormField, ref: any) => {
    const {
      checkboxes,
      name,
      helpMessage = undefined,
      label,
      className = undefined,
      size = 'lg',
      ...rest
    } = props;

    return (
      <Form.Group
        ref={ref}
        className={[
          styles.formGroup,
          size === 'sm' ? styles.sm : styles.lg,
          className,
        ]
          .filter(Boolean)
          .join(' ')}
      >
        <FieldLabel>{label} </FieldLabel>
        <div className={styles.controlWrapper}>
          <Form.Control
            className={styles.control}
            accepter={CheckboxGroup}
            name={name}
            {...rest}
          >
            {checkboxes.map((c, i) => (
              <Checkbox key={i} value={c.value}>
                {c.label}
              </Checkbox>
            ))}
          </Form.Control>
          {helpMessage ? (
            <Form.HelpText>{helpMessage}</Form.HelpText>
          ) : null}
        </div>
      </Form.Group>
    );
  },
);

export default CheckboxFormField;
